import { PipesModule } from './../pipes/pipes.module';
import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { NopagefoundComponent } from './nopagefound/nopagefound.component';
import { FooterComponent } from './footer/footer.component';
import { SettingsService } from '../services/service.index';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GooglePlacesComponent } from './google-places/google-places.component';
import { GoogleMapsModule } from '@angular/google-maps'
import { MatInputModule } from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

@NgModule({
  imports: [
      RouterModule,
      CommonModule,
      PipesModule,
      GoogleMapsModule,
      MatInputModule,
      MatFormFieldModule
  ],
  declarations: [
     HeaderComponent,
     FooterComponent,
     SidebarComponent,
     BreadcrumbsComponent,
     NopagefoundComponent,
     GooglePlacesComponent,
  ],
  exports:[
     HeaderComponent,
     FooterComponent,
     SidebarComponent,
     BreadcrumbsComponent,
     NopagefoundComponent,
     GooglePlacesComponent
  ],
  providers: [SettingsService],
  bootstrap: []
})
export class SharedModule { }
